import React from 'react';

const NotFound = () => {
    const errorStyle = {
        color: "red",
        padding: "10px",
        fontFamily: "Sans-Serif",
        fontWeight: "bold"
    };

    return (
        <>
            <h1>OSUWMC Smart Badge</h1>
            <h1 style={errorStyle}>We can't find the page you are looking for.</h1>
      </>
    );
}

export default NotFound;